import { RestSlice } from '../../../../../redux/rest.slice';
import { ApiEndpoints, ImportUniqueKey } from '@rcp/types';

export const importUniqueKeySlice = new RestSlice<ImportUniqueKey>('import-unique-key', ApiEndpoints.ImportUniqueKey);
export default importUniqueKeySlice.rests.reducer;
